import VueScrollTo from "vue-scrollto";

const SCROLLABLE_OVERFLOW_Y_VALS = ['scroll', 'auto'];

export default {
  scrollTo(e, duration = 500, options) {
    const el = typeof e  === 'string' ? document.getElementById(e) : e;
    if(el) {
      const container = this.getScrollParent(el);
      const o = Object.assign({container}, options);
      VueScrollTo.scrollTo(el, duration, o);
    }
  },
  getScrollParent(el) {
    let result;
    if (el.tagName === 'BODY') {
      result = window;
    } else if (SCROLLABLE_OVERFLOW_Y_VALS.indexOf(getComputedStyle(el).overflowY) > -1) {
      result = el;
    }

    return result || this.getScrollParent(el.parentNode);
  }
}